import { SVGProps } from 'react';

const IcUnavailableBooking = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='250'
      height='277'
      viewBox='0 0 293.332 325.001'
      fill='none'
      {...props}
    >
      <path
        d='M109.185 271.376L86.3701 248.626L123.851 211.251L86.3701 173.876L109.185 151.126L146.666 188.501L184.148 151.126L206.962 173.876L169.481 211.251L206.962 248.626L184.148 271.376L146.666 234.001L109.185 271.376ZM32.5925 325.001C23.6295 325.001 15.9567 321.819 9.57404 315.455C3.19135 309.09 0 301.439 0 292.501V65.0003C0 56.0628 3.19135 48.4117 9.57404 42.0471C15.9567 35.6824 23.6295 32.5001 32.5925 32.5001H48.8887V0H81.4812V32.5001H211.851V0H244.444V32.5001H260.74C269.703 32.5001 277.376 35.6824 283.758 42.0471C290.141 48.4117 293.332 56.0628 293.332 65.0003V292.501C293.332 301.439 290.141 309.09 283.758 315.455C277.376 321.819 269.703 325.001 260.74 325.001H32.5925ZM32.5925 292.501H260.74V130.001H32.5925V292.501ZM32.5925 97.5004H260.74V65.0003H32.5925V97.5004Z'
        fill='#F5F5F5'
      />
    </svg>
  );
};

export default IcUnavailableBooking;
